"use client";

import { cn } from "@frontend/shared/lib/utils";
import { motion } from "framer-motion";
import { useTranslations } from "@frontend/lib/next-intl-typed";

const CURVES = [
  {
    src: "/images/sscurves/white/white-1.svg",
    width: 1540,
    duration: 14,
    top: -20,
  },
  {
    src: "/images/sscurves/white/white-2.svg",
    width: 1540,
    duration: 10,
    top: -10,
  },
  {
    src: "/images/sscurves/white/white-3.svg",
    width: 1540,
    duration: 18,
    top: -25,
  },
  {
    src: "/images/sscurves/white/white-4.svg",
    width: 1540,
    duration: 6,
    top: -15,
  },
  {
    src: "/images/sscurves/white/white-5.svg",
    width: 1560,
    duration: 22,
    top: -15,
  },
  {
    src: "/images/sscurves/white/white-6.svg",
    width: 1560,
    duration: 16,
    top: -18,
  },
];

interface CalculatingPricesPillProps {
  label?: string;
  className?: string;
}

export function CalculatingPricesPill({
  label,
  className,
}: CalculatingPricesPillProps) {
  const t = useTranslations("InsuranceConnector");
  const displayLabel = label ?? t("CalculatingPrices");
  return (
    <div
      className={cn(
        "w-full h-16 flex flex-col items-center justify-center rounded-full overflow-hidden relative bg-gradient-to-r from-[#DCF7FF] to-[#8DD6FF]",
        className,
      )}
    >
      {CURVES.map((curve) => (
        <div key={curve.src} className="absolute inset-0 overflow-hidden">
          <motion.div
            className="flex relative"
            style={{ width: curve.width * 2, top: curve.top }}
            animate={{ x: [0, -curve.width] }}
            transition={{
              duration: curve.duration,
              repeat: Number.POSITIVE_INFINITY,
              ease: "linear",
            }}
          >
            <img
              src={curve.src}
              alt=""
              className="shrink-0"
              style={{ width: curve.width, height: "auto" }}
            />
            <img
              src={curve.src}
              alt=""
              className="shrink-0"
              style={{ width: curve.width, height: "auto" }}
            />
          </motion.div>
        </div>
      ))}
      <div className="absolute inset-0 z-[5] backdrop-blur-[2px] bg-white/20 rounded-full" />
      <p className="relative z-10 text-md font-semibold text-black">
        {displayLabel}
      </p>
    </div>
  );
}
